<template>
<div class="crm content" ref="wrapper">
	<component :is="href('/interactions/crm/details').content" />
	<vue-funnel-graph 
		v-if="isFunnelVisible && sources.length"
		:width="$refs.wrapper && $refs.wrapper.offsetWidth"
		:height="height" 
		:labels="labels"
		:values="values" 
		:colors="colors" 
		:sub-labels="subLabels" 
		:direction="direction"
		:animated="true" 
		:display-percentage="true"
	></vue-funnel-graph>
</div>
</template>
<script>
import hreflang from '@/lib/hreflang'
import { VueFunnelGraph } from 'vue-funnel-graph-js';
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'

let colorsMap = {
	direct: '#65bd7d', 
	search: '#ea4335',
	social: '#4687dd',
	display: '#d07a6b',
	referral: '#f4b607',
	message: '#ff7bac',
	other: '#aeaeae'
}

export default {
	name: 'CrmInteraction',
	mixins: [ hreflang ],
	data() {
		return {
			isFunnelVisible: false,
			resizeTimeout: null,
			direction: 'horizontal',
			height: 300,
			width: 600
		}
	},
	computed: {
		...mapGetters("aida", ["values"]),
		...mapState({
			stages: state => state.aida.stages,
			sources: state => state.aida.sources
		}),
		labels() {
			return _.keys(this.stages).map(label => _.startCase(label))
		},
		subLabels() {
			return this.sources.map(label => _.startCase(label))
		},
		colors() {
			return this.sources.map(color => colorsMap[color])
		}
	},
	props: {
		showDetails: Boolean,
	},
	components: {
		VueFunnelGraph
	},
	mounted() {
		this.isFunnelVisible = this.$refs.wrapper && this.$refs.wrapper.offsetWidth > 0
		window.addEventListener('resize', this.handleResize)
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize)
	},
	created() {
		this.document(require('documents/en/interactions/crm-details.md'), 'en')
	},
	methods: {
		handleResize() {
			if (this.resizeTimeout) clearTimeout(this.resizeTimeout)
			this.resizeTimeout = setTimeout(() => {
				this.isFunnelVisible = false
				this.$nextTick(() => {
					this.isFunnelVisible = true
				})
			}, 200)
		}
	}
}
</script>
<style lang="less" scoped>
@import url('~whitebox-presentation/src/assets/variables.less');
@import url('~whitebox-presentation/src/assets/mixins.less');

/deep/ .svg-funnel-js {
	margin-bottom: @gap * 3;
	margin-top: @gap * 2.5;
	&:not(.svg-funnel-js--vertical) .svg-funnel-js__label:not(:first-child) {
		border-left: 1px solid @shadow-25;
	}
	.svg-funnel-js__labels {

		.svg-funnel-js__label {
			padding-left: @gap * 2;
			.label__percentage {
				color: @gray-50;
				font-size: @font-size-s;
				font-weight: @normal;
				line-height: 1;
			}    
			.label__value {
				color: @black;
				margin-bottom: 0;
				font-weight: @bold;
				font-size: @font-size-m;
			}
			.label__title {
				color: @blue;
				font-size: @font-size-l;
				line-height: 1;
			}
			.label__segment-percentages {
				background-color: #fff;
				height: 300px;
				padding: @gap * 2;
				ul li {
					color: @black;
				}
				ul li .percentage__list-label {
					background-color: @magenta;
					color: @gray-0;
					padding: @gap/2.5 @font-size/2;
					border-radius: @font-size;
					font-size: @font-size;
					font-weight: 300;
					float: right;
					transform: translateY(-@gap / 2.5);
				}
				ul li:first-child {
					margin-top: 0;
				}
			}
		}
	}
	.svg-funnel-js__subLabels {
		.svg-funnel-js__subLabel--title {
			color: @black;
			font-size: @font-size;
		}
		.svg-funnel-js__subLabel--color {
            width: @gap*2;
            height: @gap*2;
		}
	}
}

</style>